import React from 'react';
import { AccessDeniedPage, Footer } from '@cs-cms/ui';
import CpsPage from '../../../../../packages/ui/src/pages/CpsPage';
import { useSapInvoiceDocuments } from '../lib/useSapInvoiceDocuments';
import { parseSapInvoiceSearchParams } from '../lib/parseSapInvoiceSearchParams';
import { useSearchParams } from 'react-router-dom';
import { SapInvoiceDocumentsGrid } from './SapInvoiceDocumentsGrid';
import { SapInvoiceTopBar } from './SapInvoiceTopBar';

export const SapInvoiceDocumentsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const parsedParams = parseSapInvoiceSearchParams(searchParams);
  const {
    isAccessDenied,
    isLoading,
    columns,
    gridData,
    totalCount,
    skip,
    pageSize,
    sort,
    openDocumentLoading,
    translate,
    onPageChange,
    onSortChange,
    openDocument
  } = useSapInvoiceDocuments();

  if (isAccessDenied) {
    return <AccessDeniedPage />;
  }

  return (
    <CpsPage>
      <SapInvoiceTopBar />
      <SapInvoiceDocumentsGrid
        columns={columns}
        gridData={gridData}
        totalCount={totalCount}
        skip={skip}
        pageSize={pageSize}
        sort={sort}
        isLoading={isLoading}
        openDocumentLoading={openDocumentLoading}
        translate={translate}
        onPageChange={onPageChange}
        onSortChange={onSortChange}
        openDocument={openDocument}
        indexId={parsedParams?.indexId}
      />
      <Footer />
    </CpsPage>
  );
};
